import React from "react"
import { useCuttingPlanStore } from "../../../../stores/cuttingPlanStore";
import Pattern from "../../../../components/Pattern/Pattern";
import { Container, Form } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const RebarCpPatterns = () => {
    const allPatterns = useCuttingPlanStore(state => state.allPatterns);

    const showedPatterns = allPatterns.filter(pattern => pattern.show);

    const checkedFloors = useCuttingPlanStore(state => state.checkedFloors);
    const allFloors = useCuttingPlanStore(state => state.allFloors);
    const allDiameters = useCuttingPlanStore(state => state.allDiameters);
    const rebarInformation = useCuttingPlanStore(state => state.rebarInformation);
    const overlapRatio = useCuttingPlanStore(state => state.overlapRatio);

    const showLowerFloorPatterns = useCuttingPlanStore(state => state.showLowerFloorPatterns);
    const setShowLowerFloorPatterns = useCuttingPlanStore(state => state.setShowLowerFloorPatterns);

    const showLowerFloorPatternsButtonVisible = Math.min(...checkedFloors) > Math.min(...allFloors.map(floor => floor.value));

    const { t } = useTranslation();

    return (
        <Container fluid className='border border-top-0 p-3' style={{ backgroundColor: 'white' }}>
            {showLowerFloorPatternsButtonVisible &&
                <div className='d-flex justify-content-end mb-2'>
                    <Form>
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            label={t("Alt katlara ait kesimleri de göster.")}
                            defaultChecked={showLowerFloorPatterns}
                            onChange={(e) => {
                                setShowLowerFloorPatterns(e.target.checked);
                            }}
                        />
                    </Form>
                </div>
            }
            {showedPatterns
                .sort((a, b) => a.patternNo - b.patternNo)
                .map((pattern, i) => (
                    <Pattern
                        key={i}
                        floorAvailable={true}
                        pattern={pattern}
                        allFloors={allFloors.map(floor => floor.label)}
                        donatiDict={rebarInformation}
                        checkedFloors={checkedFloors}
                        bindirmeOrani={overlapRatio}
                        ratio={overlapRatio}
                        version={2}
                    />
                ))}
        </Container>
    )
}

export default RebarCpPatterns;